module.exports = __webpack_public_path__ + "img/essence_seventhtoken.6a53749.png";